<template>
  <Header />

  <div class="main-height">
    <section class="activated">
      <div class="container">
        <div class="inner-container">

          <div class="row">
            <div class="col-12">
              <h2 class="fw-bold">
                Our systems are too busy
              </h2>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="text-3 mt-2 text-justify">
                <p>
                  Kindly send us a WhatsApp message and our team will assist you with your order.
                </p>
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
                <a :href="whatsAppUrl" target="_blank" rel="noopener noreferrer" class="btn text-white w-100 whatsapp-button" >
                  <template>
                    <img :src="whatsappIcon" alt="WhatsApp" style="width:20px; margin-right:6px;">
                  </template>
                  Send WhatsApp Message
                </a>
             </div>
          </div>

        </div>
      </div>
    </section>
  </div>

  <Footer />
</template>

<script>
import { defineComponent } from 'vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import whatsappIcon from '@/assets/WhatsApp.svg'


export default defineComponent({
  name: 'WhatsAppSupport',

  components: {
    Header,
    Footer
  },

  data() {
    return {
      whatsAppOrderId: '',
      whatsappIcon
    }
  },

  computed: {
    whatsAppUrl() {
      const text = encodeURIComponent(
          `I would like to order package with orderId=${this.whatsAppOrderId}`
      )
      const whatsappUrl = process.env.VUE_APP_WHATSAPP_URL;

      return `${whatsappUrl}?text=${text}`;
    }
  },

  beforeMount() {
    this.whatsAppOrderId = sessionStorage.getItem('whatsAppOrderId');

    if (!this.whatsAppOrderId) {
      this.$router.replace('/plans');
    }
  }
})
</script>

<style>
@import '../assets/style.css';
</style>